import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { InventoryService } from 'app/services/inventory.service';
import { BarcodeScannerLivestreamComponent } from 'ngx-barcode-scanner';
import { NgxTouchKeyboardComponent, NgxTouchKeyboardDirective } from 'ngx-touch-keyboard';
import { Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Component({
	selector: 'app-single-bin-scan',
	templateUrl: './single-bin-scan.component.html',
	styleUrls: ['./single-bin-scan.component.scss']
})
export class SingleBinScanComponent implements OnInit, OnChanges, AfterViewInit{
    @Input() viewing_item: any = false;
    @Input() bins: any = false;
	@Input() window_active: any = false;
    @Output() reload_lookup: any = new EventEmitter<any>()

    @ViewChild('hiddenScanInput') hiddenScanInput: ElementRef;
	@ViewChild(NgxTouchKeyboardDirective) keyboard!: NgxTouchKeyboardDirective;

	// Enhanced scan capture
	public keyBuffer = '';
	private readonly MIN_BARCODE_LENGTH = 4; // Minimum barcode length
	private readonly MAX_BARCODE_LENGTH = 50; // Maximum barcode length
	private subscriptions: Subscription[] = [];
	private timeouts: any[] = [];
	private intervals: any[] = [];
  
	skuSearchRef = new UntypedFormControl('');
	showcontrols: Boolean = false;
	recdoc_only = new UntypedFormControl(true);
    isScanning:any = false;
    lastScanTime = 0;
    private timeUpdateInterval: any;
    hiddenScanControl: UntypedFormControl = new UntypedFormControl('');
    scanStatus: 'idle' | 'success' | 'error' | 'warning' | 'processing' = 'idle';
    statusMessage: any = false; 
    isSearchMode = false;
    isMobile = false;
	scanLabel: any = 'Ready';
	expectedScanType: 'DOLLY' | 'BIN' | 'SKU';
    keyboardListenerEnabled = true;
	private dollycode = 'DOLLY';
	MODE: any = false || 'add' || 'put';
	dollyitems: any = [];
	dollyitems_reversed: any = [];
	bin_selected: any = false;
	item_to_add: any = false;
	dolly: any = false;
	user: any = false;
	multiple_selection: any = false;
	keyboard_open: any = false;
	move_in_progress: any = false;

	startbin = new UntypedFormControl('');
	dontshowbins = ['ZPOREQ', 'RECDOC'];
	constructor(private globalSearchService: GlobalSearchService, private cdr: ChangeDetectorRef, private inventoryService: InventoryService){}


	ngOnChanges(changes: SimpleChanges): void {
		if(changes.viewing_item){
			if(this.viewing_item.currentValue){
				// this.notificationHandler('information', 'item loaded')
			}
		}

		if(changes.window_active){
			if(changes.window_active.currentValue === 'singlebinscan'){
				setTimeout(() => {
					this.keyboardListenerEnabled = true;
					// Force readonly on hidden input to prevent keyboard
					if (this.hiddenScanInput) {
						this.hiddenScanInput.nativeElement.setAttribute('readonly', 'readonly');
						this.hiddenScanInput.nativeElement.setAttribute('inputmode', 'none');
					}
					// Focus scanner input after view init to prepare for scanning
					setTimeout(() => {
						this.focusScannerInput();
					}, 100);

				}, 350)
			}else{
				this.keyboardListenerEnabled = false;
			}
		}
	}


	ngOnInit(): void {
		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});
		this.inventoryService.getVerifiedBinListing().subscribe((res: any) => {
			this.bins = res;
		})


		this.MODE = false;
		this.updateMessage()

		this.recdoc_only.valueChanges.subscribe((newV)=>{
			this.bin_selected = false;
			this.multiple_selection = false;
			this.bin_selected = false;
			this.updateMessage();
			setTimeout(()=>{
				this.showcontrols = false;
			}, 500)
		})

	}

	emitChange(){
		this.reload_lookup.emit();
	}

	binExists(bins, input){
		return bins.find((bin) => 
			bin.bin?.toLowerCase() == input.toLowerCase() ||
			bin.location?.toLowerCase() == input.toLowerCase()
		) ?? false;
	}

	matchBarcodes(items, search): Array<any>{
		let exacts = [];
		let possibles = [];
		items.forEach(i => {
			let proceed = true;
			i.barcodes.forEach(upc => {
				if(proceed){
					if (upc.toUpperCase() === search.toUpperCase()) { 
						exacts.push(i) 
						proceed = false;
					}
					if (upc.slice(-12).toUpperCase() === search.slice(-12).toUpperCase()) { 
						possibles.push(i)
						proceed = false;
					}
					if (upc.slice(0, 12).toUpperCase() === search.slice(0, 12).toUpperCase()) { 
						possibles.push(i) 
						proceed = false;
					}
				}
			});
		});

		if(exacts.length){
			return exacts;
		}else if(possibles.length){
			return possibles;
		}else{
			return [];
		}

	}

	updateMessage(){
		this.scanLabel = 'Ready'


		switch(this.MODE ?? ''){
			case 'put':
				if(!this.bin_selected){
					this.statusMessage = 'Scan put away bin';
					this.expectedScanType = 'BIN';
				}else{
					this.statusMessage = 'Scan sku to put away';
					this.expectedScanType = 'SKU';
				}
				break;
			case 'add':
					if(this.recdoc_only.value){
						this.bin_selected = 'RECDOC';
						this.statusMessage = 'Scan SKU to add';
						this.expectedScanType = 'SKU';
					}else{
						if(this.bin_selected){
							this.expectedScanType = 'SKU';
							this.statusMessage = 'Scan SKU to add'
						}else{
							this.expectedScanType = 'BIN';
							this.statusMessage = 'Scan bin to pull from';
						}
					}
				break;
				
			default:
				this.statusMessage = 'Scan dolly'
				this.expectedScanType = 'DOLLY';
				break;
		}
		this.isScanning = false;
		this.scanStatus = 'idle';
	}


	private async processScanInput(barcode: string): Promise<void> {
		//ignore scans while bin move in prog
		if(this.move_in_progress){return};

		if (!barcode || barcode.trim() === '') {return;}

		const trimmed = barcode.trim();
		if (trimmed.length < 1 || trimmed.length > 100) {
			this.clearScanBuffer();
			return;
		}
		// Update last scan time
		this.lastScanTime = Date.now();
		this.startTimeUpdateInterval();
		this.isScanning = true;
		this.scanStatus = 'processing';
		const input: any = barcode.trim();

		if(!this.dolly){	
			this.getDolly(input);
			this.updateMessage();
			return;
		}

		if(input.toLowerCase() == this.dollycode.toLowerCase()){
			this.switchMode();
			return;
		}else{
			switch(this.MODE){
				case 'put':
					this.scanLabel = 'Processing';
					this.statusMessage = 'putting...';

					if(!this.bin_selected){
						const exists = this.verifybin(input.toUpperCase());
						if(exists){
							this.bin_selected = input.toUpperCase();
							this.updateMessage();
						}else{
							this.scanStatus = 'error';
							this.scanLabel = 'Ready';
							this.statusMessage = `Bin ${input} does not exist`;
							this.bin_selected = false;
						}
						return;
					}

					if(!this.item_to_add){						
						const match = this.matchBarcodes([this.dollyitems_reversed[0]], input.toUpperCase())
						if(match.length){
							this.moveItemToBin(this.bin_selected);
						}else{
							this.scanStatus = 'error';
							this.scanLabel = 'Ready';
							this.statusMessage = `UPC does not match sku`
							this.item_to_add = false;
						}
					}
					break;
				case 'add':
					const recdoc_items_only = this.recdoc_only.value;
					this.scanLabel = 'Processing';
					this.statusMessage = 'adding...';

					if(!this.bin_selected){
						let exists = false;
						if(!recdoc_items_only){
							this.bin_selected = input.toUpperCase();
							exists = this.verifybin(this.bin_selected);
						}else{
							this.bin_selected = 'RECDOC';
							exists = true;
						}

						//verify bin exists
						if(exists){
							this.scanLabel = 'Ready';
							this.statusMessage = `Bin selected ${this.bin_selected} - Scan Sku`;
						}else{
							this.scanStatus = 'error';
							this.scanLabel = 'Error';
							this.statusMessage = `Bin ${this.bin_selected} does not exist`;
							this.bin_selected = false;
						}

						//interrupt script if user needs to supply both bin and id
						if(!recdoc_items_only){
							return;
						}
					}


					//get item - if cant display error
					if(!this.item_to_add){
						this.item_to_add = await this.getItem(input);
						if(!this.item_to_add || (Array.isArray(this.item_to_add) && this.item_to_add.length === 0)){
							this.scanLabel = 'Error';
							this.scanStatus = 'error';
							this.statusMessage = 'Item does not exist';
							if(!this.recdoc_only.value){
								this.bin_selected = false;
							}
						}else{
							if(this.item_to_add.length == 1){
								this.item_to_add = this.item_to_add[0];
							}else{
								this.multiple_selection = [...this.item_to_add];
								this.scanLabel = 'Ready';
								this.item_to_add = false;

							}
						}
						
					}

					//verify selected bin exists on this item
					if(this.item_to_add && this.bin_selected){
						const exists = this.binExists(this.item_to_add.bins_sorted, this.bin_selected);

						if(exists){
							this.addItemToDolly(this.item_to_add, this.bin_selected);
						}else{
							this.scanLabel = 'Error';
							this.scanStatus = 'error';
							if(this.recdoc_only.value){
								this.statusMessage = 'Item scanned is not in RECDOC';
							}else{
								this.statusMessage = 'Bin scanned does not exist on this item';
							}
							this.item_to_add = false;
							this.bin_selected = false;
						}

					}
					break;
				default:
					break;
			}
			this.isScanning = false;
		}
	}

	otherbinshidden(bins){
		let count = bins.length;
		let hidden = 0;

		bins.forEach(bin => {
			if(this.dontshowbins.includes(bin.bin)){
				hidden++
			}
		});

		if(hidden == count){
			return true;
		}else{
			return false;
		}
	}

	selectItem(item){
		this.item_to_add = item;
		this.multiple_selection = false;
		this.processScanInput(item.stockid);
	}

	async getItem(itemsearch): Promise<any>{
		const data = { stockid: itemsearch, 'type':['stickerscanout']};
		this.scanLabel = 'Processing'	
		
		//cancel previous in progress subs
		this.unsuball();

		if(itemsearch.length){
			const results: any = await this.firstValueFrom(this.inventoryService.loadItemBinsBarcodes(data.stockid) );
			let item;

			if (!results.length) {
				this.notificationHandler('danger', 'No items for this UPC');
				return false;
			}

			if(results.length){
				let matched = this.matchBarcodes(results, itemsearch)
				if(matched.length == 1){
					item = matched[0];	
					const contains_bin = this.containsBin(item.bins_sorted, this.bin_selected) 
					return [{...item, recdoc_bin_present: contains_bin}];
				}else{
					let items = []
					for(let i = 0; i < matched.length; i++){
						item = matched[i];
						//multiple items - check if bins match current selected to pull from
						const contains_bin = this.containsBin(item.bins_sorted, this.bin_selected) ;
						if(contains_bin){
							items.push({...item, recdoc_bin_present: contains_bin});
						}
						if(i == matched.length-1){
							return items;
						}
					}
				}	
			}
		}
	}

	containsBin(bins_sorted, bin){
		let recdoc = false;
		
		if(bins_sorted.length && bin){
			bins_sorted.forEach(b => {
				if(b.bin.toUpperCase() == bin.toUpperCase()){
					recdoc = bin
				}
			});
		}
		return recdoc;
	}


	verifybin(bin){
		const exists = this.bins.find((b)=>{
			if(b.bin.toUpperCase() == bin){
				return b;
			}
		});

		const ret = exists ? true : false;
		return ret;
	}

	sortAllBins(items: Array<any>){
		items.forEach((i)=>{
			i.bins_sorted = this.sortbins(i.bins);
		})
		return items;
	}

	sortbins(bins){
		const nopes = ['ZPOREQ'];
		bins = (bins ?? []).filter((b)=>{
			if(b.quantity > 0){ return b; }
		});

		const sorted = bins.sort((n1, n2) => {
			if (n1.quantity > n2.quantity) { return -1; }
			if (n1.quantity < n2.quantity) { return 1; }
			return 0;
		});
		const filtered = [...sorted].filter((bin)=>{
			if(!nopes.includes(bin.bin.toUpperCase()) && !bin.bin.toUpperCase().includes("DOLLY")){
				return bin;
			}
		})
		return filtered ?? [];
	}

	getDolly($code){
		//reloads dolly based on code supplied -> dollies table cintains these
		if($code && $code != ''){
			this.scanLabel = 'Processing';
			this.inventoryService.getDolly($code).subscribe((res: any)=>{
				if(res.success){
					this.dolly = res.dolly;
					if(res?.items){
						const sorted = this.sortAllBins(res.items);
						this.dollyitems = sorted;
						this.dollyitems_reversed = [...sorted].reverse();
					}else{
						this.dollyitems = [];
						this.dollyitems_reversed = []
					}
					this.dollycode = res.dolly.code;
					this.MODE = 'add';
					this.scanLabel = 'Ready';
					this.updateMessage();
					this.scrollTop();

				}else{
					this.statusMessage = res.msg
					this.scanLabel = 'Ready'
					this.scanStatus = 'error';
				}
			})
		}
	}

	scrollTop(){
		setTimeout(()=>{
			document.querySelector('#toptire').scrollTo(0,0);	
		},750)
	}

	unsuball(){
		this.subscriptions.forEach((sub)=>{
			sub.unsubscribe();
		})
		this.subscriptions = [];
	}


	moveItemToBin(bin){
		const from_bin = this.dolly.bin;
		const to_bin = bin.toUpperCase();
		const item_to_move = this.dollyitems_reversed[0];

		const items = [{
			'stockid': item_to_move.stockid,
			'lineid': item_to_move.lineid,
			'bin': from_bin,
			'description':item_to_move.description,
			'moveQty': 1,
			'price':item_to_move.price,
			'qoh':'',
			'supplierno':'',
			'dolly_id': this.dolly.id,
		}];


		this.statusMessage = 'putting...';

		this.move_in_progress = this.inventoryService.moveItemsToBin(items, to_bin).subscribe((results: any) => {	
			if(results.success){
				const item_removed = this.dollyitems.pop();
				this.dollyitems_reversed = [...this.dollyitems].reverse();
				this.scanLabel = 'Ready';
				this.item_to_add = false;
				this.bin_selected = false;
				this.notificationHandler('success', 'Item moved')
				this.audioPlay();
				this.updateMessage();
			}else{
				this.scanLabel = 'Ready'
				this.statusMessage = false;
				this.audioPlayBad();
			}

			//they scan fast and alot when things are slow - little buffer
			setTimeout(()=>{
				this.move_in_progress = false;
			}, 500) 

			this.bin_selected = false;
			
		});
	}

	addItemToDolly(item, bin = false){
		if(this.recdoc_only.value){
			this.bin_selected = 'RECDOC';
		}

		const data = {
			user: this.user.user.userid,
			cart : {
				dolly_id: this.dolly.id,
				stockid: item.stockid
			},
			move: {
				items: [{
					'stockid': item.stockid,
					'lineid': item.lineid,
					'bin': this.bin_selected,
					'description': item.description,
					'moveQty': 1,
					'price': item.price,
					'qoh': '',
					'supplierno': '',
				}],
				to: this.dolly.bin,
				user: this.user.user.userid
			}
		}

		//dolly bin comes from dollies tbl
		this.inventoryService.addToDolly(data).subscribe((res)=>{
			if(res.success){
				item.bins_sorted = this.sortbins(res.bins.length ? res.bins : []);
				item.lineid = this.dollyitems.length + 1;
				this.dollyitems.push(item);
				this.dollyitems_reversed = [...this.dollyitems].reverse();
				this.statusMessage = false;
				this.scanLabel = 'Ready';
				this.bin_selected = false;
				this.item_to_add = false;
				document.getElementById('toptire').scrollIntoView({block: "start", inline: "nearest"})
				this.audioPlay();
				this.updateMessage();
			}else{
				this.notificationHandler('danger', res.msg);
				this.audioPlayBad();
			}
		})
	}


	audioPlay() {
		const audio = new Audio('/assets/pristine-609.mp3');
		const play = audio.play();
		if (play !== undefined) {
			play.catch(error => {
				
			}).then(() => {
				
			});
		}
	}

	audioPlayBad() {
		const audio = new Audio('/assets/glitch.mp3');
		const play = audio.play();
		if (play !== undefined) {
			play.catch(error => {
				
			}).then(() => {
				
			});
		}
	}

	switchMode(){
		if(this.MODE == 'put' || !this.MODE){
			this.MODE = 'add'
		}else{
			this.MODE = 'put';
			this.item_to_add = false;
			this.multiple_selection = false;
			this.bin_selected = false;
		}
		setTimeout(()=>{
			this.updateMessage();
		}, 1000);
		
	}

	notificationHandler(type: string, message: string){
		if(['success','warning','danger','information'].includes(type.toLowerCase())){
			this.globalSearchService.showNotification(message, type, 'top', 'right');
		}
	}

	firstValueFrom(source: Observable<any>): any {
		const res = new Promise<any>((resolve, reject) => {
			const subscription = source.subscribe({
				next: value => {
					resolve(value);
					subscription.unsubscribe();
				},
				error: err => reject(err),
				complete: () => {
					reject(new Error('nope'));
				}
			});
			this.subscriptions.push(subscription);
		});
		return res;
	}

	//scanner functions

	onHiddenInputFocus(): void {
		// Immediately blur to prevent keyboard popup
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.blur();
		}
	}


	onHiddenInputKeyDown(event: KeyboardEvent): void {
		// Only handle Enter key, let other keys pass through to document listener
		if (event.key === 'Enter') {
			event.preventDefault();
			// Use the keyBuffer instead of the form control value to avoid conflicts
			if (this.keyBuffer.trim()) {
				this.processScanInput(this.keyBuffer.trim());
				this.clearScanBuffer();
			}
		}
	}



	ngAfterViewInit(): void {
		// Force readonly on hidden input to prevent keyboard
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.setAttribute('readonly', 'readonly');
			this.hiddenScanInput.nativeElement.setAttribute('inputmode', 'none');
		}

		// Focus scanner input after view init to prepare for scanning
		setTimeout(() => {
			this.focusScannerInput();
		}, 100);


		//overide ngx keyboard close panel key to act like enter button
		const originalClose = this.keyboard.closePanel.bind(this.keyboard);
		this.keyboard.closePanel = () => {
			originalClose();
			const search = this.keyBuffer.trim()
			if(search.length && search != ''){
				this.processScanInput(search);
				this.keyBuffer = ''
			}else{
				this.updateMessage();
			}
		};
	}

	togglekeyboard(keyboard){
		keyboard.togglePanel();

		if(keyboard.isOpen){
			this.statusMessage = '';
			this.isScanning = false;
			this.keyBuffer = '';

			console.log(keyboard);
		}else{
			this.skuSearchRef.setValue('')
			this.updateMessage();
		}
		
	}


	private focusScannerInput(): void {
		// Focus on the hidden scan input to prepare for barcode scanning
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.focus();
		}
	}

	@HostListener('document:keydown', ['$event'])
	onDocumentKeyDown(event: KeyboardEvent): void {
		const target = event.target as HTMLElement;


		// Allow normal input in search mode for search input fields
		if (this.isSearchMode && (
			target.classList.contains('search-input-field') ||
			target.classList.contains('mat-input-element') ||
			target.tagName === 'INPUT' ||
			target.tagName === 'TEXTAREA'
		)) {
			return; // Don't prevent default behavior for search inputs
		}


		// Skip keyboard listener if disabled
		if (!this.keyboardListenerEnabled) {
			return;
		}

		// Handle barcode scanner input FIRST - build buffer but don't process until Enter
		// Only build buffer in scanner mode, not search mode
		if (event.key.length === 1 && this.isValidScanCharacter(event.key) && !this.isSearchMode) {
			this.keyBuffer += event.key;
			this.isScanning = true;
			// Prevent default behavior to avoid keyboard popup
			event.preventDefault();
			return; // Don't process yet, just build buffer
		}

		// Handle Enter key - process complete barcode (barcode scanner completion)
		// Only process in scanner mode, not search mode
		if (event.key === 'Enter' && !this.isSearchMode) {
			event.preventDefault();
			if (this.keyBuffer.trim()) {
				this.processScanInput(this.keyBuffer.trim());
				this.clearScanBuffer();
			}
		}

		// Handle Escape key - clear buffer
		if (event.key === 'Escape') {
			this.clearScanBuffer();
		}
	}

	private isValidScanCharacter(key: string): boolean {
		// Allow alphanumeric characters, common barcode symbols, and special characters
		return /^[a-zA-Z0-9\-_\.\+\*\#\@\$\%\&\=\!\?\(\)\[\]\{\}\|\\\/\:\;\<\>\,\~\`\s]$/.test(key);
	}

	private startTimeUpdateInterval(): void {
		// Clear existing interval
		if (this.timeUpdateInterval) {
			clearInterval(this.timeUpdateInterval);
			// Remove from tracking array
			const index = this.intervals.indexOf(this.timeUpdateInterval);
			if (index > -1) {
				this.intervals.splice(index, 1);
			}
		}

		// Start new interval to update display every second
		this.timeUpdateInterval = setInterval(() => {
			if (this.lastScanTime) {
				// Use setTimeout to defer change detection and avoid ExpressionChangedAfterItHasBeenCheckedError
				const timeoutId = setTimeout(() => {
					this.cdr.detectChanges();
				}, 0);
				this.timeouts.push(timeoutId);
			}
		}, 1000);

		// Track the interval
		this.intervals.push(this.timeUpdateInterval);
	}

	private clearScanBuffer(): void {
		this.keyBuffer = '';
		this.isScanning = false;
	}
}